import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    paddingVertical: 16,
    marginTop: 1,
  },
  textStyle: theme => ({
    fontSize: 16,
    color: theme.colors.textColorNine,
  }),
  rowStyle: {
    marginTop: 20,
  },
});
